// extracted by mini-css-extract-plugin
export default {"NoResults":"SearchResultAlert_NoResults__p9sTW","abstract":"SearchResultAlert_abstract__F1sbB","errorIcon":"SearchResultAlert_errorIcon__iW18w"};